"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthSuiteSubscriptionsService = exports.authSuiteSubscriptionsService = void 0;
var tslib_1 = require("tslib");
var auth_suite_fetch_1 = require("../../auth-suite-fetch");
var direct_payment_subscription_status_1 = require("./models/direct-payment-subscription-status");
var getSubscriptionDetailsPath = "access/purchase";
var directPaymentsSubscriptionsPath = "directPayments/subscriptions";
var getSubscriptionDetails = function (contentAccessMethod) {
    var providerCode = contentAccessMethod.providerCode, providerUserId = contentAccessMethod.providerUserId;
    var path = "".concat(getSubscriptionDetailsPath, "/").concat(providerCode, "/").concat(providerUserId);
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization
        .get({
        path: path,
    })
        .then(function (details) {
        return tslib_1.__assign(tslib_1.__assign({}, details), { inBillingGracePeriod: details.inBillingGracePeriod || false });
    });
};
var addCouponToSubscription = function (request) {
    var payload = {
        couponCode: request.couponCode,
    };
    var body = JSON.stringify(payload);
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.post({
        body: body,
        path: "".concat(directPaymentsSubscriptionsPath, "/").concat(request.subscriptionId, "/coupon"),
    });
};
var cancelDirectPaymentSubscription = function (request) {
    var path = "".concat(directPaymentsSubscriptionsPath, "/").concat(request.subscriptionId);
    var payload = {
        status: direct_payment_subscription_status_1.DIRECT_PAYMENT_SUBSCRIPTION_STATUS.CANCELED,
    };
    var body = JSON.stringify(payload);
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.patch({
        body: body,
        path: path,
    });
};
exports.authSuiteSubscriptionsService = {
    addCouponToSubscription: addCouponToSubscription,
    cancelDirectPaymentSubscription: cancelDirectPaymentSubscription,
    getSubscriptionDetails: getSubscriptionDetails,
};
var AuthSuiteSubscriptionsService = /** @class */ (function () {
    function AuthSuiteSubscriptionsService() {
        return exports.authSuiteSubscriptionsService;
    }
    return AuthSuiteSubscriptionsService;
}());
exports.AuthSuiteSubscriptionsService = AuthSuiteSubscriptionsService;
